import React, { useCallback, useRef } from "react";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { profilUpdated, verification, verifyPassword, saveImageProfil } from "../Redux/usersReduce";
import { useDispatch } from "react-redux";
import { grossisteGetById } from "../Redux/grossisteReduce";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-multi-lang'

function Profile({ obj }) {
  const t = useTranslation();
  console.log(obj)
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }
  const dispatch = useDispatch();
  var id = obj.user.id;
  var id_role = obj.user.id_role;
  const [email, setEmail] = React.useState(obj.user.email);
  const [login, setLogin] = React.useState(obj.user.login);
  const [passwordCurrent, setPasswordCurrent] = React.useState("");
  const [passwordNew, setPasswordNew] = React.useState("");
  const [passwordConfirm, setPasswordConfirm] = React.useState("");
  const [detailGro, setDetailGro] = React.useState({});
  const [file, setFile] = React.useState(null);
  const [fileNames, setFileNames] = React.useState(obj.user.image);
  const saveCalled = useRef(false);

  function uploadImage(event) {
    let ImageFile = event.target.files[0];
    if (ImageFile) {
      setFile(ImageFile);
      setFileNames(event.target.files[0].name);
    }
  }

  async function submitForm(event) {

    const isStrongPassword = (pwd) => {
      const minLength = 12;
      const hasUpperCase = /[A-Z]/.test(pwd);
      const hasLowerCase = /[a-z]/.test(pwd);
      const hasNumber = /[0-9]/.test(pwd);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(pwd);
      return pwd.length >= minLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
    };

    if(passwordConfirm !== "" && passwordNew !== "" && passwordCurrent !== "") {
      if(passwordNew !== passwordConfirm) {
        saveCalled.current = false;
        notify(2, t("verif_password"));
        return;
      }

      if(!isStrongPassword(passwordNew)) {
        saveCalled.current = false;
        notify(2, t("password_not_strong"));
        return;
      }

      dispatch(verifyPassword({ password: passwordCurrent, id })).then(async data => {
        if (data.payload === true) {
          notify(1, t("password_update"));
          var filename = fileNames;
          if (file !== null) {
            const dataArray = new FormData();
            dataArray.append("file", file);
            dataArray.append("name", file.name);
            if (saveCalled.current) return;
            saveCalled.current = true;
            var val = await dispatch(saveImageProfil(dataArray));
            filename = val.payload.filename;
          }
          dispatch(profilUpdated({ password: passwordNew, id, filename, email }));
          setTimeout(() => {
            window.location.reload()
          }, 1000);
        } else {
          saveCalled.current = false;
          notify(2, t("current_password_incorrect"));
        }
      });
    } else {
      if (file !== null) {
        var filename = fileNames;
        const dataArray = new FormData();
        dataArray.append("file", file);
        dataArray.append("name", file.name);
        if (saveCalled.current) return;
        saveCalled.current = true;
        var val = await dispatch(saveImageProfil(dataArray));
        filename = val.payload.filename;
        dispatch(profilUpdated({ id, filename, email }));
        setTimeout(() => {
          window.location.reload()
        }, 1000);
      } else {
        notify(2, t("all_obligatoire"));
      }
    }
  }


  const handleGetUserDetails = async (obj) => {
    try {

      const result = await dispatch(grossisteGetById(obj.user.id_grossiste));
      const userD = result.payload;
      setDetailGro(userD);
    } catch (error) {
      console.error("Error getting user details:", error);
      localStorage.clear();
      window.location.replace("/login");
    }
  };

  //verif token
  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);


  React.useEffect(() => {
    if (id_role == 6) handleGetUserDetails(obj)
  }, []);
  return (
    <>
      <ToastContainer />
      <Container fluid>
        <Card>
          <Card.Header>
            <Card.Title as="h4">{t("mon_profil")}</Card.Title>
          </Card.Header>
          <Card.Body>
            {id_role == 6 ?
              <Row className="details-grossiste">
                <Col className="pr-4 mb-4" md="3" ><strong>Nom prénom : </strong>{detailGro.Nom + " " + detailGro.Prenom}</Col>
                {/* <Col className="pr-4 mb-4" md="3" ><strong>Code client : </strong>{detailGro.Code_client}</Col> */}
                <Col className="pr-4 mb-4" md="3" ><strong>Raison sociale : </strong>{detailGro.Raison_sociale}</Col>
                <Col className="pr-4 mb-4" md="3" ><strong>Adresse : </strong>{detailGro.Ligne_adresse + " " + detailGro.Ville + " " + detailGro.Code_postale}</Col>
                <Col className="pr-4 mb-4" md="3" ><strong>Téléphone : </strong>{detailGro.Tel + "/" + detailGro.Mob}</Col>
              </Row> : null}

            <Row>
              <Col className="pr-4 mb-4" md="12" >
                <Form.Group>
                  <label>{t("User.login")}</label>
                  <Form.Control
                    id="Login_user"
                    defaultValue={login}
                    placeholder={t("login")}
                    type="text"
                    readOnly
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col className="pr-4 mb-4" md="12">
                <Form.Group>
                  <label>{t("email")} </label>
                  <Form.Control
                    defaultValue={email}
                    placeholder={t("email")}
                    type="text"
                    onChange={(value) => {
                      setEmail(value.target.value);
                    }}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>

            {/* <Row>
              <Col className="pr-4 mb-4" md="12">
                <Form.Group>
                  <label>{t('image')} </label>
                  <div className="custom-file">
                    <Form.Control
                      id="test"
                      name="file"
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      onChange={(e) => uploadImage(e)}
                      className="custom-file-input"
                    />
                    <label className="custom-file-label" htmlFor="test">
                      {fileNames ? fileNames : t("Choose_file")}
                    </label>
                  </div>
                </Form.Group>
              </Col>

            </Row> */}
            <hr></hr>
            <Row>
              <Col className="pr-4 mb-4" md="12">
                <Form.Group>
                  <label>{t("password_change")}</label>
                  <Form.Control
                    id="mdp_user"
                    defaultValue=""
                    placeholder={t("current_password")}
                    type="password"
                    autoComplete="off"
                    onChange={(value) => {
                      setPasswordCurrent(value.target.value);
                    }}
                  ></Form.Control>
                </Form.Group>
                <br></br>
                <Form.Group>
                  <Form.Control
                    id="mdp_user"
                    defaultValue=""
                    placeholder={t("new_password")}
                    type="password"
                    onChange={(value) => {
                      setPasswordNew(value.target.value);
                    }}
                  ></Form.Control>
                  <div style={{ marginTop: "5px", fontSize: "0.75rem", color: "#555" }}>
                    <ul
                      style={{
                        paddingLeft: "20px",
                        marginBottom: "0",
                        color: "#555",
                        fontSize: "0.75rem",
                        lineHeight: "1.5",
                        listStyleType: "disc",
                      }}
                    >
                      <li>Doit contenir au moins 12 caractères</li>
                      <li>Au moins une lettre majuscule</li>
                      <li>Au moins une lettre minuscule</li>
                      <li>Au moins un chiffre</li>
                      <li>Au moins un caractère spécial</li>
                    </ul>
                  </div>
                </Form.Group>

                <br></br>
                <Form.Group>

                  <Form.Control
                    id="mdp_user"
                    defaultValue=""
                    placeholder={t("confirm_password")}
                    type="password"
                    onChange={(value) => {
                      setPasswordConfirm(value.target.value);
                    }}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <br clear="all"></br>
            <Button
              className="btn-fill pull-right"
              type="button"
              variant="info"
              onClick={submitForm}
            >
              Enregistrer
            </Button>
            <div className="clearfix"></div>
          </Card.Body>
        </Card>
      </Container >
    </>
  );
}

export default Profile;
